<template>
  <component
    :is="name"
    :fill="fill"
    :height="height"
    :width="width"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'

const ComponentContext = require.context('@/views/svgs-icons', true, /\.vue$/i, 'lazy')
const iconComponents = {}

ComponentContext.keys().forEach((componentFilePath) => {
  const componentName = componentFilePath.split('/').pop().split('.')[0]
  iconComponents[componentName] = defineAsyncComponent(() => ComponentContext(componentFilePath))
})

export default {
  name: 'BaseIcon',
  components: iconComponents,
  props: {
    name: {
      type: String,
      required: true
    },
    fill: {
      type: String,
    },
    height: {
      type: [String, Number],
    },
    width: {
      type: [String, Number],
    }
  }
}
</script>